import { atomWithStorage } from "jotai/utils";

const MOBILE_APP_BANNER_STORE_INDEX = "bx-mobile-app-banner-store";

interface IMobileAppBannerStore {
  isVisible: boolean;
}

const initialState: IMobileAppBannerStore = {
  isVisible: true,
};

export const MobileAppBannerStore = atomWithStorage<IMobileAppBannerStore>(MOBILE_APP_BANNER_STORE_INDEX, initialState);
